const validationRules: Record<string, { regex: RegExp; maxLength: number }> = {
  mobile: { regex: /^[0-9]*$/, maxLength: 10 },
  pincode: { regex: /^[0-9]*$/, maxLength: 6 },
  pan: { regex: /^[A-Z0-9]*$/i, maxLength: 10 },
  gst: { regex: /^[A-Z0-9]*$/i, maxLength: 15 },
  fssai: { regex: /^[A-Z0-9]*$/i, maxLength: 14 },
  license: { regex: /^[A-Z0-9]*$/i, maxLength: 20 },
  registration: { regex: /^[A-Z0-9]*$/i, maxLength: 20 },
  email: { regex: /^[A-Za-z0-9@._-]*$/, maxLength: 100 },
  name: { regex: /^[A-Za-z\s]*$/, maxLength: 30 },
  address: { regex: /^[A-Za-z0-9\s,.-]*$/, maxLength: 70 },
};

export const validateInput = (field: string, value: string): string => {
  const rule = validationRules[field];
  if (!rule) return value;

  if (field === "email") {
    const cleaned = value.replace(/[^A-Za-z0-9@._-]/g, ""); 
    return cleaned.slice(0, rule.maxLength);
  }

  const allowedPattern = rule.regex;
  const cleanedValue = value.split("").filter(char => allowedPattern.test(char)).join("");
  const slicedValue = cleanedValue.slice(0, rule.maxLength);

  return allowedPattern.test(slicedValue) ? slicedValue : "";
};

export const handleInputChange = (
  e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  field: string,
  setState: React.Dispatch<React.SetStateAction<string>>
): void => {
  const { value } = e.target;
  const validatedValue = validateInput(field, value);
  setState(validatedValue);
};